export * from "./confirmation-page.template";
export * from "./views/jira-template-choice/jira-choice-view-manager";
export { ConfirmationPageTemplate as default } from "./confirmation-page.template";
